export enum ErrorType {
  'ORB_A' = 'Produto não encontrado',
  'ORB_B' = 'Produtor inválido',
  'ORB_C' = 'Combinação de produtos incompatíveis',
  'ORB_D' = 'Metodos de pagamentos incompatíveis',
  'ORB_E' = 'Combinação de frete inválido',
  'ORB_F' = 'Produto do tipo assinatura não permitido',
  'ORB_G' = 'Produto principal não pode ser grátis',
  'ORB_H' = 'Não é permitido Info Produto do tipo PIN',
  'ORB_I' = 'Produto Pai',
  'ORB_J' = 'Esse Bump ja está cadastrado',
  'ORB_X' = 'Produto não pode ser Assinatura',

  'COMMOM_400' = 'Erro nos campos enviados',
  'COMMOM_401' = 'Permissão negada'
}
